import { CountryCode } from '@qred/shared-enums';
import {
  formatOrganizationNumber,
  normalizeCompanyNumberForBackend,
} from '~/helpers/formatters.helper';
import { getCookieValue } from '~/helpers/utils';
import { ICardApplicationForm } from '~/interfaces/cardApplication';
import {
  CardApplicationDTO,
  CardDataPointsShared,
} from '~/schemas/DTO/cardApplicationSchemas';

// TODO: do we still need to pass currentForm to this function?
export const mapToCardApplicationForm = (
  data: CardApplicationDTO,
  currentForm: ICardApplicationForm
): ICardApplicationForm => {
  let applicant = { ...currentForm.applicant };
  if (data.applicant) {
    const { firstName, lastName, ...restOfApplicantFromData } = data.applicant;
    const fullName = `${firstName || ''} ${lastName || ''}`.trim();
    applicant = {
      ...applicant,
      ...restOfApplicantFromData,
      ...(fullName && { fullName }),
    };
  }

  return {
    ...currentForm,
    applicant,
    applicationUuid: data.applicationUuid,
    organizationNumber: formatOrganizationNumber(
      data.organization.organizationNumber || ''
    ),
    companyName: data.organization.companyName,
    companyAddress: data.organization.companyAddress,
    companyType: data.organization.companyType || '',
    companyTypeCategory: data.organization.companyTypeCategory,
    creditReportProvider: data.organization.creditReportProvider,
    purposeOfCard: data.purposeOfCard,
    cardPurposeManual: data.cardPurposeManual,
    sessionId: data.sessionId,
    applicationId: data.applicationId,
    qCode: data.qCode,
    userCode: data.userCode,
    turnover: data.turnover,
  };
};

export const mapToCardApplicationDTO = ({
  form,
  market,
  currentStepNumber,
  currentStepCompleted,
  finalized,
  shouldPostApplication,
  clientId,
  dataPointsShared,
}: {
  form: ICardApplicationForm;
  market: CountryCode;
  currentStepNumber: number;
  currentStepCompleted: boolean;
  finalized: boolean;
  shouldPostApplication: boolean;
  clientId?: number;
  dataPointsShared: CardDataPointsShared;
}): CardApplicationDTO => {
  const {
    organizationNumber,
    companyType,
    companyTypeCategory,
    companyName,
    companyAddress,
    creditReportProvider,
    ...rest
  } = form;

  const requestData: CardApplicationDTO = {
    organization: {},
    completedStep: currentStepCompleted
      ? currentStepNumber
      : currentStepNumber - 1,
    market,
    currentStep: currentStepNumber,
    finalized,
    clientId,
    dataPointsShared,
    ...rest,
  };

  organizationNumber &&
    (requestData.organization.organizationNumber = normalizeCompanyNumberForBackend(
      organizationNumber,
      market
    ));
  companyType && (requestData.organization.companyType = companyType);
  companyTypeCategory &&
    (requestData.organization.companyTypeCategory = companyTypeCategory);
  companyName && (requestData.organization.companyName = companyName);
  creditReportProvider &&
    (requestData.organization.creditReportProvider = creditReportProvider);
  companyAddress && (requestData.organization.companyAddress = companyAddress);

  if (shouldPostApplication) {
    requestData.trafficCookie = getCookieValue('_ga') || '';
  }

  return requestData;
};
